<script lang="ts">

	import { setCookie } from '$services/CookieService';
	import { onMount } from 'svelte';
	import type { TestUser } from '../../domain/TestUser';

	export let testUsers: TestUser[];

	const defaultCustomerId = 'basicCustomerId';

	let selectedUser: string;

	onMount(() => {
		selectedUser = localStorage.getItem('testUserType') || defaultCustomerId;
	});

	const onChange = () => {
		const owt = testUsers.find(testUser => testUser.customerId === selectedUser)!.owt;
		setCookie('owt', owt);
		localStorage.setItem('testUserType', selectedUser);
		window.location.reload();
	};

</script>

<div class="pl_dropdown pl_m100">
	<select bind:value={selectedUser} class="js-pl_dropdown__element pl_dropdown__element" id="dropdown"
		on:change={onChange}>
		{#each testUsers as testUser}
			<option value={testUser.customerId}>{testUser.displayName}</option>
		{/each}
	</select>
	<label class="js-pl_label pl_label" for="dropdown">Select user:</label>
</div>
